import { BaseController } from '~client/controller/base-controller';
import { AuctionOfferRequest } from '~client/model/auction-offer-request';
import { SimpleChanceResponse } from '~client/model/simple-chance-response';
import { SimpleOfferResponse } from '~client/model/simple-offer-response';

/* User APIs pertaining to Auctions */
export class AuctionController extends BaseController {
  /* Returns the chances for the given offer group */
  public getChance(numTokens: number, offerGroupId: string): Promise<SimpleChanceResponse> {
    return this.get('/auction/public/chance', { numTokens, offerGroupId });
  }

  /* Returns the fees and taxes for the given offer group */
  public reviewOffer(
    request: AuctionOfferRequest,
    isPublic: boolean,
  ): Promise<SimpleOfferResponse> {
    return this.put(isPublic ? '/auction/public/checkout' : '/auction/checkout', request);
  }

  /* Allows the user to place a offer for the given offer group */
  public submitOffer(request: AuctionOfferRequest): Promise<SimpleOfferResponse> {
    return this.post('/auction/makeAuctionOffer', request);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/auction-controller.ts